export const test = {
  showModal: false,
};

export const initial = {
  showModal: false,
};



/** WEBPACK FOOTER **
 ** ./js/redux/state/iFrame.state.js
 **/